import React from 'react';
import PropTypes from 'prop-types';
import { Hero } from "../../collections/Hero";
import { InnerContent } from "./components/InnerContent";
export var Component = function Component(_ref) {
  var activeNavigationItemIndex = _ref.activeNavigationItemIndex,
      backgroundImageHeight = _ref.backgroundImageHeight,
      backgroundImageSizes = _ref.backgroundImageSizes,
      backgroundImageSrcSet = _ref.backgroundImageSrcSet,
      backgroundImageUrl = _ref.backgroundImageUrl,
      backgroundImageWidth = _ref.backgroundImageWidth,
      className = _ref.className,
      headerLogoHref = _ref.headerLogoHref,
      headerLogoSize = _ref.headerLogoSize,
      headerLogoSizes = _ref.headerLogoSizes,
      headerLogoSrc = _ref.headerLogoSrc,
      headerLogoSrcSet = _ref.headerLogoSrcSet,
      headerLogoText = _ref.headerLogoText,
      headerNavigationItems = _ref.headerNavigationItems,
      headerPrimaryCTA = _ref.headerPrimaryCTA,
      headerLogoSubText = _ref.headerLogoSubText,
      headingText = _ref.headingText,
      isHeaderBackgroundFilled = _ref.isHeaderBackgroundFilled,
      isSearchBarDateRangePickerLoading = _ref.isSearchBarDateRangePickerLoading,
      placeholderBackgroundImageUrl = _ref.placeholderBackgroundImageUrl,
      searchBarMaximumGuestsInputValue = _ref.searchBarMaximumGuestsInputValue,
      searchBarDateRangePickerLocaleCode = _ref.searchBarDateRangePickerLocaleCode,
      searchBarDatesCheckOutLabel = _ref.searchBarDatesCheckOutLabel,
      searchBarDatesCheckInLabel = _ref.searchBarDatesCheckInLabel,
      searchBarDatesInputFocusedInput = _ref.searchBarDatesInputFocusedInput,
      searchBarDatesInputOnFocusChange = _ref.searchBarDatesInputOnFocusChange,
      searchBarDatesInputValue = _ref.searchBarDatesInputValue,
      searchBarGetIsDayBlocked = _ref.searchBarGetIsDayBlocked,
      searchBarGuestsInputLabel = _ref.searchBarGuestsInputLabel,
      searchBarGuestsInputValue = _ref.searchBarGuestsInputValue,
      searchBarLocationInputValue = _ref.searchBarLocationInputValue,
      searchBarLocationInputLabel = _ref.searchBarLocationInputLabel,
      searchBarLocationOptions = _ref.searchBarLocationOptions,
      searchBarModalHeadingText = _ref.searchBarModalHeadingText,
      searchBarOnChangeInput = _ref.searchBarOnChangeInput,
      searchBarOnSubmit = _ref.searchBarOnSubmit,
      searchBarSearchButton = _ref.searchBarSearchButton;
  return React.createElement(Hero, {
    activeNavigationItemIndex: activeNavigationItemIndex,
    backgroundImageHeight: backgroundImageHeight,
    backgroundImageSizes: backgroundImageSizes,
    backgroundImageSrcSet: backgroundImageSrcSet,
    backgroundImageUrl: backgroundImageUrl,
    backgroundImageWidth: backgroundImageWidth,
    className: className,
    headerLogoHref: headerLogoHref,
    headerLogoSize: headerLogoSize,
    headerLogoSizes: headerLogoSizes,
    headerLogoSrc: headerLogoSrc,
    headerLogoSrcSet: headerLogoSrcSet,
    headerLogoSubText: headerLogoSubText,
    headerLogoText: headerLogoText,
    headerNavigationItems: headerNavigationItems,
    headerPrimaryCTA: headerPrimaryCTA,
    isHeaderBackgroundFilled: isHeaderBackgroundFilled,
    placeholderBackgroundImageUrl: placeholderBackgroundImageUrl
  }, React.createElement(InnerContent, {
    headingText: headingText,
    isSearchBarDateRangePickerLoading: isSearchBarDateRangePickerLoading,
    searchBarDateRangePickerLocaleCode: searchBarDateRangePickerLocaleCode,
    searchBarDatesCheckInLabel: searchBarDatesCheckInLabel,
    searchBarDatesCheckOutLabel: searchBarDatesCheckOutLabel,
    searchBarDatesInputFocusedInput: searchBarDatesInputFocusedInput,
    searchBarDatesInputOnFocusChange: searchBarDatesInputOnFocusChange,
    searchBarDatesInputValue: searchBarDatesInputValue,
    searchBarGetIsDayBlocked: searchBarGetIsDayBlocked,
    searchBarGuestsInputLabel: searchBarGuestsInputLabel,
    searchBarGuestsInputValue: searchBarGuestsInputValue,
    searchBarLocationInputLabel: searchBarLocationInputLabel,
    searchBarLocationInputValue: searchBarLocationInputValue,
    searchBarLocationOptions: searchBarLocationOptions,
    searchBarMaximumGuestsInputValue: searchBarMaximumGuestsInputValue,
    searchBarModalHeadingText: searchBarModalHeadingText,
    searchBarOnChangeInput: searchBarOnChangeInput,
    searchBarOnSubmit: searchBarOnSubmit,
    searchBarSearchButton: searchBarSearchButton
  }));
};
Component.displayName = 'HomepageHero';
Component.defaultProps = {
  activeNavigationItemIndex: null,
  backgroundImageHeight: undefined,
  backgroundImageSizes: undefined,
  backgroundImageSrcSet: undefined,
  backgroundImageWidth: undefined,
  className: '',
  searchBarDatesInputValue: undefined,
  searchBarGuestsInputValue: undefined,
  headerLogoHref: undefined,
  headerLogoSize: undefined,
  headerLogoSizes: undefined,
  headerLogoSrc: null,
  headerLogoSrcSet: undefined,
  headerPrimaryCTA: null,
  headerLogoSubText: undefined,
  headingText: undefined,
  isSearchBarDateRangePickerLoading: undefined,
  searchBarLocationInputValue: undefined,
  searchBarMaximumGuestsInputValue: undefined,
  placeholderBackgroundImageUrl: null,
  searchBarDateRangePickerLocaleCode: undefined,
  searchBarDatesCheckInLabel: undefined,
  searchBarDatesCheckOutLabel: undefined,
  searchBarDatesInputFocusedInput: undefined,
  searchBarDatesInputOnFocusChange: Function.prototype,
  searchBarGetIsDayBlocked: undefined,
  searchBarGuestsInputLabel: undefined,
  searchBarLocationInputLabel: undefined,
  searchBarLocationOptions: undefined,
  searchBarModalHeadingText: undefined,
  searchBarOnChangeInput: undefined,
  searchBarOnSubmit: Function.prototype,
  searchBarSearchButton: undefined,
  isHeaderBackgroundFilled: false
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  activeNavigationItemIndex: PropTypes.number,
  backgroundImageHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  backgroundImageSizes: PropTypes.string,
  backgroundImageSrcSet: PropTypes.string,
  backgroundImageUrl: PropTypes.string.isRequired,
  backgroundImageWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  headerLogoHref: PropTypes.string,
  headerLogoSize: PropTypes.oneOf(['medium', 'large', 'huge']),
  headerLogoSizes: PropTypes.string,
  headerLogoSrc: PropTypes.string,
  headerLogoSrcSet: PropTypes.string,
  headerLogoSubText: PropTypes.string,
  headerLogoText: PropTypes.string.isRequired,
  headerNavigationItems: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    subItems: PropTypes.arrayOf(PropTypes.shape({
      href: PropTypes.string.isRequired,
      target: PropTypes.string,
      text: PropTypes.string.isRequired
    })),
    target: PropTypes.string,
    text: PropTypes.string.isRequired
  })).isRequired,
  headerPrimaryCTA: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired
  }),
  headingText: PropTypes.string,
  isHeaderBackgroundFilled: PropTypes.bool,
  isSearchBarDateRangePickerLoading: PropTypes.bool,
  placeholderBackgroundImageUrl: PropTypes.string,
  searchBarDateRangePickerLocaleCode: PropTypes.string,
  searchBarDatesCheckInLabel: PropTypes.string,
  searchBarDatesCheckOutLabel: PropTypes.string,
  searchBarDatesInputFocusedInput: PropTypes.oneOf([null, 'startDate', 'endDate']),
  searchBarDatesInputOnFocusChange: PropTypes.func,
  searchBarDatesInputValue: PropTypes.shape({
    endDate: PropTypes.object,
    startDate: PropTypes.object
  }),
  searchBarGetIsDayBlocked: PropTypes.func,
  searchBarGuestsInputLabel: PropTypes.string,
  searchBarGuestsInputValue: PropTypes.number,
  searchBarLocationInputLabel: PropTypes.string,
  searchBarLocationInputValue: PropTypes.string,
  searchBarLocationOptions: PropTypes.arrayOf(PropTypes.shape({
    indent: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
    text: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  })),
  searchBarMaximumGuestsInputValue: PropTypes.number,
  searchBarModalHeadingText: PropTypes.string,
  searchBarOnChangeInput: PropTypes.func,
  searchBarOnSubmit: PropTypes.func,
  searchBarSearchButton: PropTypes.node
} : {};